<template>
    <div class="container">
        <div v-if="getNews.length === 0" class="no-content">
            <p>記事を取得できませんでした。</p>
        </div>

        <ul v-else>
            <li v-if="topNews" class="top-news">
                <a :href="topNews.link" target="_blank" class="row">
                    <span class="title"
                        ><strong>{{ topNews.title }}</strong
                        >{{ topNews.body }}</span
                    >
                    <img src="@/assets/images/design/icon_arrow-right.svg" alt="" />
                </a>
            </li>
            <li v-for="row in getNews" :key="row.link">
                <a :href="row.link" target="_blank" class="row">
                    <span class="date">{{ row.pubDate }}</span>
                    <span class="title">{{ row.title }}</span>
                    <img src="@/assets/images/design/icon_arrow-right.svg" alt="" />
                </a>
            </li>
        </ul>

        <a :href="newsUrl" target="_blank" class="to-all">すべてのお知らせを見る</a>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { newsUrl } from '@shared/const/links.js';

export default {
    props: {
        topNews: {
            type: Object, // { title: string, body: string, link: string }
            default: undefined,
        },
    },
    data() {
        return {
            newsUrl,
        };
    },
    computed: {
        ...mapGetters(['getNews']),
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/personal/main.scss';
$pr-pc: 28px;
$p-sp: 14px;

.container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    > *:not(a) {
        width: 100%;
        border-top: 1px solid #cccccc;
        border-bottom: 1px solid #cccccc;
    }
}
.no-content {
    padding: 20px 0;
    text-align: center;
}
ul {
    margin: 0;
    padding: 0;
    list-style: none;

    > :not(:last-child) {
        border-bottom: 1px solid #ccc;
    }
}
.row {
    height: 78px;
    display: grid;
    padding: 0 $pr-pc 0 20px;
    grid-template-columns: minmax(76px, auto) 1fr 12px;
    align-items: center;
    column-gap: 24px;
    color: #444;

    @include sp {
        padding: 0 $p-sp;
        grid-template-rows: auto auto;
        grid-template-areas:
            'date date icon'
            'title title icon';
        row-gap: 6px;

        .date {
            grid-area: date;
            align-self: end;
        }
        .title {
            grid-area: title;
            align-self: start;
        }
        img {
            grid-area: icon;
        }
    }

    &:hover {
        opacity: 1;
        color: #4694d8;
        background-color: #f4faff;
        text-decoration: none;

        .title {
            text-decoration: underline;
        }
        img {
            translate: 2px;
        }
    }

    .date {
        font-weight: bold;
    }
    .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    img {
        width: 16px;
        height: 16px;
        transition: translate 0.2s;
    }
}
.top-news {
    .title {
        grid-column: 1 / 3;
    }
}

.to-all {
    align-self: end;
    margin-right: $pr-pc;

    @include sp {
        margin-right: $p-sp;
    }
}
</style>
